import React from 'react'

interface CheckmarkProps {
	color?: string // color for the circle between the outer circle and checkmark
	showCircle?: boolean // flag to show/hide the outer circle (optional)
	checked?: boolean // flag to show/hide the checkmark (default: true)
}

const Checkmark = ({
	color = 'gray',
	showCircle = false,
	checked = true,
}: CheckmarkProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ minWidth: '24px', minHeight: '24px' }}
	>
		{showCircle ? (
			<>
				<circle
					cx="12"
					cy="12"
					r="11" // Outer circle radius
					stroke={color}
					strokeWidth="1"
					fill={color}
				/>
				{!checked && (
					<circle
						cx="12"
						cy="12"
						r="9" // Inner circle radius
						stroke={color}
						strokeWidth="1"
						fill="none"
					/>
				)}
				{checked && (
					<path
						d="M8 12.5L10 14.5L16 8.5"
						stroke={showCircle ? (checked ? 'white' : 'none') : color}
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				)}
			</>
		) : (
			<path
				d="M5 13l4 4L19 7"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		)}
	</svg>
)

export default Checkmark
